<template lang="pug">
div
  ul#gameresulttab.nav.nav-tabs(role='tablist')
    li.nav-item(v-if="showActionButton('adjustmentlog')" @click="refresh('adjustmentlog')")
      a#adjustmentlog-tab.nav-link(:class="{ 'active': currTab == 'adjustmentlog' }" data-toggle='tab' href='#adjustmentlog-content' role='tab' aria-controls='adjustmentlog' aria-selected='false') {{ $t("ui.adjustment_log") }}
    li.nav-item(v-if="showActionButton('bonuslog')" @click="refresh('bonuslog')")
      a#bonuslog-tab.nav-link(:class="{ 'active': currTab == 'bonuslog' }" data-toggle='tab' href='#bonuslog-content' role='tab' aria-controls='bonuslog' aria-selected='false') {{ $t("ui.bonus_log") }}
    li.nav-item(v-if="showActionButton('memberloginlog')" @click="refresh('memberloginlog')")
      a#memberloginlog-tab.nav-link(:class="{ 'active': currTab == 'memberloginlog' }" data-toggle='tab' href='#memberloginlog-content' role='tab' aria-controls='memberloginlog' aria-selected='false') {{ $t("ui.login_log") }}
    li.nav-item(v-if="showActionButton('resultchangeslog')" @click="refresh('resultchangeslog')")
      a#resultchangeslog-tab.nav-link(:class="{ 'active': currTab == 'resultchangeslog' }" data-toggle='tab' href='#resultchangeslog-content' role='tab' aria-controls='resultchangeslog' aria-selected='false') {{ $t("ui.result_changes_log") }}
    li.nav-item(v-if="showActionButton('viplog')" @click="refresh('viplog')")
      a#viplog-tab.nav-link(:class="{ 'active': currTab == 'viplog' }" data-toggle='tab' href='#viplog-content' role='tab' aria-controls='viplog' aria-selected='false') {{ $t("ui.vip_log") }}
    li.nav-item(v-if="showActionButton('membertokenlog')" @click="refresh('membertokenlog')")
      a#membertokenlog-tab.nav-link(:class="{ 'active': currTab == 'membertokenlog' }" data-toggle='tab' href='#membertokenlog-content' role='tab' aria-controls='membertokenlog' aria-selected='false') {{ $t("ui.token_log") }}
    li.nav-item(v-if="showActionButton('adjustfreebalancelog')" @click="refresh('adjustfreebalancelog')")
      a#adjustfreebalancelog-tab.nav-link(:class="{ 'active': currTab == 'adjustfreebalancelog' }" data-toggle='tab' href='#adjustfreebalancelog-content' role='tab' aria-controls='adjustfreebalancelog' aria-selected='false') {{ $t("ui.adjust_free_balance_log") }}
    li.nav-item(v-if="showActionButton('memberlog')" @click="refresh('memberlog')")
      a#memberlog-tab.nav-link(:class="{ 'active': currTab == 'memberlog' }" data-toggle='tab' href='#memberlog-content' role='tab' aria-controls='memberlog' aria-selected='false') {{ $t("ui.member_log") }}
    li.nav-item(v-if="showActionButton('membersosclicklog')" @click="refresh('membersosclicklog')")
      a#membersosclicklog-tab.nav-link(:class="{ 'active': currTab == 'membersosclicklog' }" data-toggle='tab' href='#membersosclicklog-content' role='tab' aria-controls='membersosclicklog' aria-selected='false') {{ $t("ui.member_sos_click_log") }}
    li.nav-item(v-if="showActionButton('memberwalletvoucherlog')" @click="refresh('memberwalletvoucherlog')")
      a#memberwalletvoucherlog-tab.nav-link(:class="{ 'active': currTab == 'memberwalletvoucherlog' }" data-toggle='tab' href='#memberwalletvoucherlog-content' role='tab' aria-controls='memberwalletvoucherlog' aria-selected='false') {{ $t("ui.member_wallet_voucher_log") }}
    li.nav-item(v-if="showActionButton('membervoucherredeemedlog')" @click="refresh('membervoucherredeemedlog')")
      a#membervoucherredeemedlog-tab.nav-link(:class="{ 'active': currTab == 'membervoucherredeemedlog' }" data-toggle='tab' href='#membervoucherredeemedlog-content' role='tab' aria-controls='membervoucherredeemedlog' aria-selected='false') {{ $t("ui.member_voucher_redeemed_log") }}
    li.nav-item(v-if="showActionButton('clearoutstandinglog') && isAdmin" @click="refresh('clearoutstandinglog')")
      a#clearoutstandinglog-tab.nav-link(:class="{ 'active': currTab == 'clearoutstandinglog' }" data-toggle='tab' href='#clearoutstandinglog-content' role='tab' aria-controls='clearoutstandinglog' aria-selected='false') {{ $t("ui.clear_outstanding_log") }}
    li.nav-item(v-if="showActionButton('freespinlog')" @click="refresh('freespinlog')")
      a#freespinlog-tab.nav-link(:class="{ 'active': currTab == 'freespinlog' }" data-toggle='tab' href='#freespinlog-content' role='tab' aria-controls='freespinlog' aria-selected='false') {{ $t("ui.freespin_log") }}


  #gameresulttabcontent.tab-content.tab-bordered
    #adjustmentlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'adjustmentlog' }" v-if="showActionButton('adjustmentlog')" role='tabpanel' aria-labelledby='adjustmentlog-tab')
      adjustmentLogTab(ref="adjustmentLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #bonuslog-content.tab-pane.fade(:class="{ 'active show': currTab == 'bonuslog' }" v-if="showActionButton('bonuslog')" role='tabpanel' aria-labelledby='bonuslog-tab')
      bonusLogTab(ref="bonusLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #memberloginlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'memberloginlog' }" v-if="showActionButton('memberloginlog')" role='tabpanel' aria-labelledby='memberloginlog-tab')
      loginLogTab(ref="loginLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab" @redirectReport="redirectReport")
    #resultchangeslog-content.tab-pane.fade(:class="{ 'active show': currTab == 'resultchangeslog' }" v-if="showActionButton('resultchangeslog')" role='tabpanel' aria-labelledby='resultchangeslog-tab')
      gameResultChangesLogTab(ref="gameResultChangesLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #viplog-content.tab-pane.fade(:class="{ 'active show': currTab == 'viplog' }" v-if="showActionButton('viplog')" role='tabpanel' aria-labelledby='viplog-tab')
      memberVipLogTab(ref="memberVipLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #membertokenlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'membertokenlog' }" v-if="showActionButton('membertokenlog')" role='tabpanel' aria-labelledby='membertokenlog-tab')
      memberTokenLogTab(ref="memberTokenLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #adjustfreebalancelog-content.tab-pane.fade(:class="{ 'active show': currTab == 'adjustfreebalancelog' }" v-if="showActionButton('adjustfreebalancelog')" role='tabpanel' aria-labelledby='adjustfreebalancelog-tab')
      adjustFreeBalanceLogTab(ref="adjustFreeBalanceLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #memberlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'memberlog' }" v-if="showActionButton('memberlog')" role='tabpanel' aria-labelledby='memberlog-tab')
      memberLogTab(ref="memberLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #membersosclicklog-content.tab-pane.fade(:class="{ 'active show': currTab == 'membersosclicklog' }" v-if="showActionButton('membersosclicklog')" role='tabpanel' aria-labelledby='membersosclicklog-tab')
      memberSosClickLogTab(ref="memberSosClickLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #memberwalletvoucherlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'memberwalletvoucherlog' }" v-if="showActionButton('memberwalletvoucherlog')" role='tabpanel' aria-labelledby='memberwalletvoucherlog-tab')
      memberWalletVoucherLogTab(ref="memberWalletVoucherLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #membervoucherredeemedlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'membervoucherredeemedlog' }" v-if="showActionButton('membervoucherredeemedlog')" role='tabpanel' aria-labelledby='membervoucherredeemedlog-tab')
      memberVoucherRedeemedLogTab(ref="memberVoucherRedeemedLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #clearoutstandinglog-content.tab-pane.fade(:class="{ 'active show': currTab == 'clearoutstandinglog' }" v-if="showActionButton('clearoutstandinglog') && isAdmin" role='tabpanel' aria-labelledby='clearoutstandinglog-tab')
      clearOutstandingLogTab(ref="clearOutstandingLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")
    #freespinlog-content.tab-pane.fade(:class="{ 'active show': currTab == 'freespinlog' }" v-if="showActionButton('freespinlog')" role='tabpanel' aria-labelledby='freespinlog-tab')
      freespinLogTab(ref="freespinLogTab" :operatorID="operatorID" :memberID="memberID" :currTab="currTab")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import adjustmentLogTab from "@/components/logTab/adjustmentLogTab.vue";
import bonusLogTab from "@/components/logTab/issueBonusLogTab.vue";
import loginLogTab from "@/components/logTab/loginLogTab.vue";
import gameResultChangesLogTab from "@/components/logTab/gameResultChangesLogTab.vue";
import memberVipLogTab from "@/components/logTab/memberVipLogTab.vue";
import memberTokenLogTab from "@/components/logTab/memberTokenLogTab.vue";
import adjustFreeBalanceLogTab from "@/components/logTab/adjustFreeBalanceLogTab.vue";
import memberLogTab from "@/components/logTab/memberLogTab.vue";
import memberSosClickLogTab from "@/components/logTab/memberSosClickLogTab.vue";
import memberWalletVoucherLogTab from "@/components/logTab/memberWalletVoucherLogTab.vue";
import clearOutstandingLogTab from "@/components/logTab/clearOutstandingLogTab.vue";
import freespinLogTab from "@/components/logTab/freeSpinLogTab.vue";
import memberVoucherRedeemedLogTab from "@/components/logTab/memberVoucherRedeemedLogTab.vue";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton,
    adjustmentLogTab,
    bonusLogTab,
    gameResultChangesLogTab,
    loginLogTab,
    memberVipLogTab,
    memberTokenLogTab,
    adjustFreeBalanceLogTab,
    memberLogTab,
    memberSosClickLogTab,
    memberWalletVoucherLogTab,
    memberVoucherRedeemedLogTab,
    clearOutstandingLogTab,
    freespinLogTab
  },
  props: {
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    },
    member: {
      type: Object
    }
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currTab: 'adjustmentlog'
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    refresh: function(tab) {
      switch(tab) {
        case 'adjustmentlog':
          this.tabChecking();
          break
        case 'bonuslog':
          this.currTab = 'bonuslog'
          this.$nextTick(() => {
            if(this.$refs.bonusLogTab) {
              this.$refs.bonusLogTab.refresh();
            }
          });
          break
        case 'memberloginlog':
          this.currTab = 'memberloginlog'
          this.$nextTick(() => {
            if(this.$refs.loginLogTab) {
              this.$refs.loginLogTab.refresh();
            }
          });
          break
        case 'resultchangeslog':
          this.currTab = 'resultchangeslog'
          this.$nextTick(() => {
            if(this.$refs.gameResultChangesLogTab) {
              this.$refs.gameResultChangesLogTab.refresh();
            }
          });
          break
        case 'viplog':
          this.currTab = 'viplog'
          this.$nextTick(() => {
            if(this.$refs.memberVipLogTab) {
              this.$refs.memberVipLogTab.refresh();
            }
          });
          break
        case 'membertokenlog':
          this.currTab = 'membertokenlog'
          this.$nextTick(() => {
            if(this.$refs.memberTokenLogTab) {
              this.$refs.memberTokenLogTab.refresh();
            }
          });
          break
        case 'adjustfreebalancelog':
          this.currTab = 'adjustfreebalancelog'
          this.$nextTick(() => {
            if(this.$refs.adjustFreeBalanceLogTab) {
              this.$refs.adjustFreeBalanceLogTab.refresh();
            }
          });
          break
        case 'memberlog':
          this.currTab = 'memberlog'
          this.$nextTick(() => {
            if(this.$refs.memberLogTab) {
              this.$refs.memberLogTab.refresh();
            }
          });
          break
        case 'membersosclicklog':
          this.currTab = 'membersosclicklog'
          this.$nextTick(() => {
            if(this.$refs.memberSosClickLogTab) {
              this.$refs.memberSosClickLogTab.refresh();
            }
          });
          break
        case 'memberwalletvoucherlog':
          this.currTab = 'memberwalletvoucherlog'
          this.$nextTick(() => {
            if(this.$refs.memberWalletVoucherLogTab) {
              this.$refs.memberWalletVoucherLogTab.refresh();
            }
          });
          break
        case 'membervoucherredeemedlog':
          this.currTab = 'membervoucherredeemedlog'
          this.$nextTick(() => {
            if(this.$refs.memberVoucherRedeemedLogTab) {
              this.$refs.memberVoucherRedeemedLogTab.refresh();
            }
          });
          break
        case 'clearoutstandinglog':
          this.currTab = 'clearoutstandinglog'
          this.$nextTick(() => {
            if(this.$refs.clearOutstandingLogTab) {
              this.$refs.clearOutstandingLogTab.refresh();
            }
          });
          break
        case 'freespinlog':
          this.currTab = 'freespinlog'
          this.$nextTick(() => {
            if(this.$refs.freespinLogTab) {
              this.$refs.freespinLogTab.refresh();
            }
          });
          break
      }
    },
    tabChecking() {
      if(this.showActionButton('adjustmentlog')) {
        this.currTab = 'adjustmentlog'
        this.$nextTick(() => {
          if(this.$refs.adjustmentLogTab) {
            this.$refs.adjustmentLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('bonuslog')) {
        this.currTab = 'bonuslog'
        this.$nextTick(() => {
          if(this.$refs.bonusLogTab) {
            this.$refs.bonusLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('memberloginlog')) {
        this.currTab = 'memberloginlog'
        this.$nextTick(() => {
          if(this.$refs.loginLogTab) {
            this.$refs.loginLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('resultchangeslog')) {
        this.currTab = 'resultchangeslog'
        this.$nextTick(() => {
          if(this.$refs.gameResultChangesLogTab) {
            this.$refs.gameResultChangesLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('viplog')) {
        this.currTab = 'viplog'
        this.$nextTick(() => {
          if(this.$refs.memberVipLogTab) {
            this.$refs.memberVipLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('membertokenlog')) {
        this.currTab = 'membertokenlog'
        this.$nextTick(() => {
          if(this.$refs.memberTokenLogTab) {
            this.$refs.memberTokenLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('memberlog')) {
        this.currTab = 'memberlog'
        this.$nextTick(() => {
          if(this.$refs.memberLogTab) {
            this.$refs.memberLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('membersosclicklog')) {
        this.currTab = 'membersosclicklog'
        this.$nextTick(() => {
          if(this.$refs.memberSosClickLogTab) {
            this.$refs.memberSosClickLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('memberwalletvoucherlog')) {
        this.currTab = 'memberwalletvoucherlog'
        this.$nextTick(() => {
          if(this.$refs.memberWalletVoucherLogTab) {
            this.$refs.memberWalletVoucherLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('membervoucherredeemedlog')) {
        this.currTab = 'membervoucherredeemedlog'
        this.$nextTick(() => {
          if(this.$refs.memberVoucherRedeemedLogTab) {
            this.$refs.memberVoucherRedeemedLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('clearoutstandinglog')) {
        this.currTab = 'clearoutstandinglog'
        this.$nextTick(() => {
          if(this.$refs.clearOutstandingLogTab) {
            this.$refs.clearOutstandingLogTab.refresh();
          }
        });
      }
      else if(this.showActionButton('freespinlog')) {
        this.currTab = 'freespinlog'
        this.$nextTick(() => {
          if(this.$refs.freespinLogTab) {
            this.$refs.freespinLogTab.refresh();
          }
        });
      }
    },
    redirectReport(tab) {
      this.refresh(tab)
    }
  }
};
</script>